/** @file Edit-mesh tool registration (ToolDef): title and one activation chord (viewport context). */
import type { ToolDef } from '../../stores/types';

/** KeyT activates the tool (R-E1-17 leaves T and P to E5); pointer behaviour is editMeshPointer in toolPointers. */
export const tool: ToolDef = { id: 'editMesh', title: 'tools.editMesh.title', bindings: [{ id: 'tool.editMesh', keys: 'KeyT', context: 'viewport' }] };
